import { render, staticRenderFns } from "./PatternTable.vue?vue&type=template&id=80f4b086"
import script from "./PatternTable.vue?vue&type=script&lang=js"
export * from "./PatternTable.vue?vue&type=script&lang=js"
import style0 from "./PatternTable.vue?vue&type=style&index=0&id=80f4b086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports